// ko strings for messages/library.ts. Same keys and {variables} as en there.
// {category} / {categoryLower} are the Korean category name below; Korean
// reads "{category} AI 목소리" for categories and languages alike, so
// library.of / library.ofLanguage are just the name.
import type { Dict } from "../index";

const library: Dict = {
  "library.of": "{name}",
  "library.ofLanguage": "{name}",

  // SEO (pages/models.tsx and ModelSearchPageV2)
  "library.seo.title": "AI 목소리 라이브러리{filter} | Jammable",
  "library.seo.titleFiltered": "{filter} AI 목소리 라이브러리 | Jammable",
  "library.seo.description":
    "9만 3천 개 이상의 AI 목소리 모델을 둘러보세요. 애니메이션, 게임, 만화, K팝 등 다양한 목소리로 AI 커버를 만들 수 있어요. 새 목소리가 매일 추가돼요.",
  "library.seo.ogDescription":
    "9만 3천 개 이상의 AI 목소리 모델을 둘러보세요. 애니메이션, 게임, 만화, K팝 등 다양한 목소리로 AI 커버를 만들 수 있어요.",
  "library.seo.listDescription":
    "Jammable AI 목소리. AI 커버 메이커, 텍스트 음성 변환, 보이스 체인저. 9만 3천 개 이상의 AI 목소리를 둘러보세요.",
  "library.seo.listDescriptionFiltered":
    "Jammable의 {filter} AI 목소리. 목소리를 골라 {filter} AI 커버를 만들어 보세요. 텍스트 음성 변환도 지원해요. 라이브러리에 9만 3천 개 이상의 목소리가 있어요.",
  "library.crumb.home": "홈",
  "library.crumb.library": "AI 목소리 라이브러리",
  "library.crumb.filter": "{category} 목소리",

  // ModelSearchPageV2
  "library.title": "목소리 라이브러리",
  "library.subtitle":
    "9만 3천 개 이상의 목소리. 탭해서 들어 보거나 바로 커버를 만들어 보세요.",
  "library.train": "내 목소리 학습시키기",
  "library.search": "목소리 검색",
  "library.searchIn": "{categoryLower} 목소리 검색",
  "library.categoriesNav": "목소리 카테고리",
  "library.all": "전체",
  "library.moreCategories": "카테고리 더보기",
  "library.fewerCategories": "카테고리 접기",
  "library.collections": "컬렉션",
  "library.collections.prev": "이전 컬렉션",
  "library.collections.next": "컬렉션 더보기",
  "library.collection.voices": "목소리 {n}개",
  "library.voicesIn": "{category} 목소리",
  "library.allVoices": "모든 목소리",
  "library.empty.title": "목소리를 찾지 못했어요",
  "library.empty.body":
    "다른 이름으로 검색하거나 직접 목소리를 학습시켜 보세요.",
  "library.loadMore": "목소리 더 불러오기",

  // components/voices/VoiceSortTabs
  "library.sort.aria": "목소리 정렬",
  "library.sort.hot": "오늘의 인기 급상승",
  "library.sort.hot.short": "인기 급상승",
  "library.sort.top": "가장 많이 사용됨",
  "library.sort.top.short": "많이 사용",
  "library.sort.liked": "좋아요 많은 순",
  "library.sort.liked.short": "좋아요순",
  "library.sort.new": "최신순",
  "library.sort.new.short": "최신",

  // CategoryHub
  "library.hub.title":
    "{category} AI 목소리: {category} 목소리로 AI 커버 만들기 | Jammable",
  "library.hub.titlePage": "{category} AI 목소리, {page}페이지 | Jammable",
  "library.hub.description":
    "Jammable에서 {count}개 이상의 {category} AI 목소리를 둘러보세요. 원하는 목소리를 골라 AI 커버를 만들거나 AI 보이스 체인저로 사용할 수 있어요.",
  "library.hub.descriptionPage":
    "Jammable의 {category} AI 목소리, 사용 횟수순 {page}/{lastPage}페이지. 원하는 목소리를 골라 AI 커버를 만들거나 AI 보이스 체인저로 사용할 수 있어요.",
  "library.hub.name": "{category} AI 목소리",
  "library.hub.crumbVoices": "AI 목소리",
  "library.hub.voices": "목소리",
  "library.hub.page": "{page}페이지",
  "library.hub.h1": "{category} AI 목소리",
  "library.hub.intro":
    "{count}개 이상의 {category} AI 목소리를 둘러보세요. 하나를 골라 AI 커버를 만들거나 보이스 체인저로 사용할 수 있어요.",
  "library.hub.popular": "인기 {categoryLower} 목소리",
  "library.hub.mostUsedPage":
    "가장 많이 사용된 {categoryLower} 목소리, {page}/{lastPage}페이지",
  "library.hub.noMatch": "검색과 일치하는 {categoryLower} 목소리가 없어요.",
  "library.hub.openLibrary": "목소리 라이브러리에서 열기",
  "library.hub.moreCategories": "다른 카테고리 둘러보기",
  "library.hub.faq": "자주 묻는 질문",
  "library.hub.keepExploring": "계속 둘러보기",
  "library.hub.moreWays": "Jammable로 만들 수 있는 더 많은 방법.",
  "library.hub.link.aiCover": "AI 커버 생성기",
  "library.hub.link.voiceChanger": "AI 보이스 체인저",
  "library.hub.link.allVoices": "모든 AI 목소리 둘러보기",
  "library.hub.pages": "페이지",
  "library.hub.first": "처음",
  "library.hub.prev": "이전",
  "library.hub.next": "다음",
  "library.hub.last": "마지막",
  "library.hub.faq1.q": "{category} AI 목소리란 무엇인가요?",
  "library.hub.faq1.a":
    "{category} AI 목소리는 {categoryLower} 카테고리에 속한 목소리 모델로, AI 커버를 만들거나 내 목소리를 바꾸는 데 사용할 수 있어요. Jammable에는 {count}개 이상이 있으며 새 목소리가 매일 추가돼요.",
  "library.hub.faq2.q": "{category} AI 목소리는 어떻게 사용하나요?",
  "library.hub.faq2.a":
    "{category} 목소리를 열고, 사용 권리가 있는 오디오를 추가하거나 직접 녹음한 뒤 생성 버튼을 누르세요. Jammable이 보컬을 그 목소리로 변환해 몇 초 만에 완성된 커버를 보여 드려요.",
  "library.hub.faq3.q": "{category} 목소리는 몇 개나 있나요?",
  "library.hub.faq3.a":
    "현재 Jammable에는 {count}개 이상의 {category} AI 목소리가 있고, 커뮤니티가 새 목소리를 업로드하고 학습시키면서 라이브러리가 매일 커지고 있어요.",

  // Category names, as they read before "AI 목소리".
  "library.cat.public-figure": "유명인",
  "library.cat.music": "음악",
  "library.cat.cartoon": "만화",
  "library.cat.gaming": "게임",
  "library.cat.fictional": "가상 캐릭터",
  "library.cat.anime": "애니메이션",
  "library.cat.influencer": "인플루언서",
  "library.cat.singer": "가수",
  "library.cat.comedy": "코미디",
  "library.cat.pop": "팝",
  "library.cat.youtuber": "유튜버",
  "library.cat.tv-show": "TV 프로그램",
  "library.cat.rap": "랩",
  "library.cat.fictional-character": "가상 캐릭터",
  "library.cat.movie": "영화",
  "library.cat.movies": "영화",
  "library.cat.funny": "웃긴",
  "library.cat.kpop": "K팝",
  "library.cat.k-pop": "K팝",
  "library.cat.parody": "패러디",
  "library.cat.animation": "애니메이션",
  "library.cat.animated": "애니메이션",
  "library.cat.rock": "록",
  "library.cat.vtuber": "버튜버",
  "library.cat.fantasy": "판타지",
  "library.cat.game": "게임",
  "library.cat.entertainment": "엔터테인먼트",
  "library.cat.rapper": "래퍼",
  "library.cat.horror": "공포",
  "library.cat.actor": "배우",
  "library.cat.actors": "배우",
  "library.cat.actress": "여배우",
  "library.cat.meme": "밈",
  "library.cat.action": "액션",
  "library.cat.educational": "교육",
  "library.cat.hip-hop-rap": "힙합/랩",
  "library.cat.hip-hop": "힙합",
  "library.cat.adventure": "어드벤처",
  "library.cat.tv": "TV",
  "library.cat.female": "여성",
  "library.cat.male": "남성",
  "library.cat.superhero": "슈퍼히어로",
  "library.cat.drama": "드라마",
  "library.cat.sci-fi": "SF",
  "library.cat.science-fiction": "SF",
  "library.cat.alternative": "얼터너티브",
  "library.cat.metal": "메탈",
  "library.cat.technology": "테크",
  "library.cat.indie": "인디",
  "library.cat.celebrity": "연예인",
  "library.cat.fiction": "픽션",
  "library.cat.american": "미국",
  "library.cat.british": "영국",
  "library.cat.australian": "호주",
  "library.cat.latino": "라틴",
  "library.cat.mexico": "멕시코",
  "library.cat.villain": "악당",
  "library.cat.politics": "정치인",
  "library.cat.president": "대통령",
  "library.cat.animal": "동물",
  "library.cat.animals": "동물",
  "library.cat.dog": "강아지",
  "library.cat.cat": "고양이",
  "library.cat.sports": "스포츠",
  "library.cat.wrestling": "프로레슬링",
  "library.cat.streamer": "스트리머",
  "library.cat.country": "컨트리",
  "library.cat.robot": "로봇",
  "library.cat.sound-effects": "효과음",
  "library.cat.historical": "역사 인물",
  "library.cat.folk": "포크",
  "library.cat.r-b": "R&B",
  "library.cat.rnb": "R&B",
  "library.cat.jazz": "재즈",
  "library.cat.reggaeton": "레게톤",
  "library.cat.electronic": "일렉트로닉",
  "library.cat.pop-music": "팝",
  "library.cat.comic": "코믹스",
  "library.cat.demon": "악마",
  "library.cat.news": "뉴스",
  "library.cat.artist": "아티스트",
  "library.cat.artistas": "아티스트",
  "library.cat.cantantes": "가수",
  "library.cat.cantante": "가수",
  "library.cat.personajes": "캐릭터",
  "library.cat.character": "캐릭터",
  "library.cat.singing": "노래",
  "library.cat.mystery": "미스터리",
  "library.cat.christmas": "크리스마스",
  "library.cat.sitcom": "시트콤",
  "library.cat.pirate": "해적",
  "library.cat.toy": "장난감",
  "library.cat.classic": "클래식",
  "library.cat.art": "아트",
  "library.cat.poetry": "시",
  "library.cat.food": "음식",
  "library.cat.fashion": "패션",
  "library.cat.family": "가족",
  "library.cat.podcast": "팟캐스트",
  "library.cat.radio": "라디오",
  "library.cat.ai": "AI",
  "library.cat.artificial-intelligence": "인공지능",
  "library.cat.song": "노래",
  "library.cat.ringtone": "벨소리",
  "library.cat.web-series": "웹 시리즈",
  "library.cat.idol": "아이돌",
  "library.cat.dub": "더빙",
  "library.cat.80s": "80년대",
  "library.cat.indie-games": "인디 게임",
  "library.cat.game-show": "게임쇼",
  "library.lang.japanese": "일본어",
  "library.lang.japenese": "일본어",
  "library.lang.korean": "한국어",
  "library.lang.spanish": "스페인어",
  "library.lang.english": "영어",
  "library.lang.french": "프랑스어",
  "library.lang.italian": "이탈리아어",
  "library.lang.german": "독일어",
  "library.lang.deutsch": "독일어",
  "library.lang.russian": "러시아어",
  "library.lang.hebrew": "히브리어",
  "library.lang.chinese": "중국어",
  "library.lang.arabic": "아랍어",
  "library.lang.swedish": "스웨덴어",
  "library.lang.polish": "폴란드어",
  "library.lang.turkish": "튀르키예어",
  "library.lang.finnish": "핀란드어",
  "library.lang.greek": "그리스어",
  "library.lang.indonesian": "인도네시아어",
  "library.lang.thai": "태국어",
  "library.lang.hungarian": "헝가리어",
  "library.lang.filipino": "필리핀어",
  "library.lang.malaysian": "말레이어",
  "library.lang.portuguese": "포르투갈어",
  "library.lang.brasileiro": "브라질 포르투갈어",
  "library.lang.pt-br": "브라질 포르투갈어",
  "library.lang.romanian": "루마니아어",
  "library.lang.hindi": "힌디어",
  "library.lang.dutch": "네덜란드어",
  "library.lang.czech": "체코어",
  "library.lang.vietnamese": "베트남어",
};

export default library;
